import { ComponentProps } from 'react';
import styled, { css, useTheme } from 'styled-components';

import { SpacingGridMultiple } from '@hookdeck/theme';

import { Div, StyledUtilsProps } from '../helpers/StyledUtils';
import { ThreeDEyeDarkIcon, ThreeDEyeLightIcon } from './icons/3dEye';
import { AdyenLightIcon } from './icons/Adyen';
import { AkeneoLightIcon } from './icons/Akeneo';
import { AWSS3LightIcon } from './icons/AWSS3';
import { AWSSNSLightIcon } from './icons/AWSSNS';
import { AWSSQSLightIcon } from './icons/AWSSQS';
import { BondsmithLightIcon } from './icons/Bondsmith';
import { CloudsignalsLightIcon } from './icons/Cloudsignals';
import { CommercelayerLightIcon } from './icons/Commercelayer';
import { WebhookLightIcon } from './icons/Webhook';
import { CourierLightIcon } from './icons/Courier';
import { FiservLightIcon } from './icons/Fiserv';
import { FrontappLightIcon } from './icons/Frontapp';
import { GitHubLightIcon } from './icons/GitHub';
import { GitLabLightIcon } from './icons/GitLab';
import { HubSpotLightIcon } from './icons/HubSpot';
import { LinearLightIcon } from './icons/Linear';
import { MailgunLightIcon } from './icons/Mailgun';
import { OuraLightIcon } from './icons/Oura';
import { PersonaLightIcon } from './icons/Persona';
import { PipedriveLightIcon } from './icons/Pipedrive';
import { PostmarkLightIcon } from './icons/Postmark';
import { PropertyFinderLightIcon } from './icons/PropertyFinder';
import { PylonLightIcon } from './icons/Pylon';
import { RazorpayLightIcon } from './icons/Razorpay';
import { RepayLightIcon } from './icons/Repay';
import { SendgridLightIcon } from './icons/Sendgrid';
import { ShoplineLightIcon } from './icons/Shopline';
import { SlackLightIcon } from './icons/Slack';
import { SolidgateLightIcon } from './icons/Solidgate';
import { SquareLightIcon } from './icons/Square';
import { StripeLightIcon } from './icons/Stripe';
import { SvixLightIcon } from './icons/Svix';
import { SyncteraLightIcon } from './icons/Synctera';
import { TebexLightIcon } from './icons/Tebex';
import { TelnyxLightIcon } from './icons/Telnyx';
import { TokenioLightIcon } from './icons/Tokenio';
import { TwitchLightIcon } from './icons/Twitch';
import { TypeformLightIcon } from './icons/Typeform';
import { VercelLightIcon } from './icons/Vercel';
import { WixLightIcon } from './icons/Wix';
import { XLightIcon } from './icons/X';
import { SanityLightIcon } from './icons/Sanity';
import { RechargeLightIcon } from './icons/Recharge';
import { PraxisLightIcon } from './icons/Praxis';
import { CustomerioLightIcon } from './icons/Customerio';
import { WhatsAppLightIcon } from './icons/WhatsApp';
import { FacebookLightIcon } from './icons/Facebook';
import { ReplicateLightIcon } from './icons/Replicate';
import { TikTokLightIcon } from './icons/TikTok';
import { AirwallexLightIcon } from './icons/Airwallex';
import { ZendeskDarkIcon, ZendeskLightIcon } from './icons/Zendesk';
import { TreezorLightIcon } from './icons/Treezor';
import { GocardlessLightIcon } from './icons/Gocardless';

export const svg_icons = {
  loading: (props) => (
    <svg {...props} viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15">
        <animate
          attributeName="r"
          from="15"
          to="15"
          begin="0s"
          dur="0.8s"
          values="15;9;15"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="60" cy="15" r="9" fillOpacity="0.3">
        <animate
          attributeName="r"
          from="9"
          to="9"
          begin="0s"
          dur="0.8s"
          values="9;15;9"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="0.5"
          to="0.5"
          begin="0s"
          dur="0.8s"
          values=".5;1;.5"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="105" cy="15" r="15">
        <animate
          attributeName="r"
          from="15"
          to="15"
          begin="0s"
          dur="0.8s"
          values="15;9;15"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
  slack_colored: () => (
    <>
      <path
        d="M6.78194 14.375C6.78194 15.4158 5.93174 16.266 4.89097 16.266C3.8502 16.266 3 15.4158 3 14.375C3 13.3343 3.8502 12.4841 4.89097 12.4841H6.78194V14.375Z"
        fill="#E01E5A"
      />
      <path
        d="M7.73633 14.375C7.73633 13.3343 8.58653 12.4841 9.6273 12.4841C10.6681 12.4841 11.5183 13.3343 11.5183 14.375V19.1098C11.5183 20.1506 10.6681 21.0008 9.6273 21.0008C8.58653 21.0008 7.73633 20.1506 7.73633 19.1098V14.375Z"
        fill="#E01E5A"
      />
      <path
        d="M9.6273 6.78194C8.58653 6.78194 7.73633 5.93174 7.73633 4.89097C7.73633 3.8502 8.58653 3 9.6273 3C10.6681 3 11.5183 3.8502 11.5183 4.89097V6.78194H9.6273Z"
        fill="#36C5F0"
      />
      <path
        d="M9.62572 7.73474C10.6665 7.73474 11.5167 8.58494 11.5167 9.62571C11.5167 10.6665 10.6665 11.5167 9.62572 11.5167H4.89097C3.8502 11.5167 3 10.6665 3 9.62571C3 8.58494 3.8502 7.73474 4.89097 7.73474H9.62572Z"
        fill="#36C5F0"
      />
      <path
        d="M17.2227 9.62571C17.2227 8.58494 18.0729 7.73474 19.1136 7.73474C20.1544 7.73474 21.0046 8.58494 21.0046 9.62571C21.0046 10.6665 20.1544 11.5167 19.1136 11.5167H17.2227V9.62571Z"
        fill="#2EB67D"
      />
      <path
        d="M16.2683 9.62572C16.2683 10.6665 15.4181 11.5167 14.3773 11.5167C13.3365 11.5167 12.4863 10.6665 12.4863 9.62572V4.89097C12.4863 3.8502 13.3365 3 14.3773 3C15.4181 3 16.2683 3.8502 16.2683 4.89097V9.62572Z"
        fill="#2EB67D"
      />
      <path
        d="M14.3773 17.2189C15.4181 17.2189 16.2683 18.0691 16.2683 19.1099C16.2683 20.1507 15.4181 21.0009 14.3773 21.0009C13.3365 21.0009 12.4863 20.1507 12.4863 19.1099V17.2189H14.3773Z"
        fill="#ECB22E"
      />
      <path
        d="M14.3773 16.2661C13.3365 16.2661 12.4863 15.4159 12.4863 14.3752C12.4863 13.3344 13.3365 12.4842 14.3773 12.4842H19.112C20.1528 12.4842 21.003 13.3344 21.003 14.3752C21.003 15.4159 20.1528 16.2661 19.112 16.2661H14.3773Z"
        fill="#ECB22E"
      />
    </>
  ),
  doppler_colored: () => (
    <>
      <defs xmlns="http://www.w3.org/2000/svg">
        <linearGradient
          id="paint0_linear_610_1042"
          x1="71.835"
          x2="8.2341"
          y1="-2.9931"
          y2="82.312"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#409FF8" offset=".036458" />
          <stop stopColor="#1673FF" offset=".5" />
          <stop stopColor="#516FF7" offset="1" />
        </linearGradient>
      </defs>
      <g xmlns="http://www.w3.org/2000/svg" transform="scale(.26667)" fill="none">
        <path
          d="m1.6523 0c-0.71885 0-1.1446 0.79424-0.7576 1.4l16.135 25.255c1.3343 2.0885 3.6346 3.3524 6.113 3.3524h21.824c7.9991 0 13 7.0729 12.97 14.992s-5.3582 14.922-12.97 14.922h-23.3c-1.3369 0-2.4157 1.0838-2.4157 2.4208v25.239c0 1.3356 1.0765 2.4182 2.412 2.4182h29.764c25.754 0 38.557-24.434 38.573-45s-12.638-45-38.573-45zm10.586 59.992h-5.7943c-3.5591 0-6.4443 3.3575-6.4443 7.4991v21.847c0 0.359 0.29103 0.6501 0.65004 0.6501h5.7943c3.5591 0 6.4443-3.3575 6.4443-7.4991v-21.847c0-0.359-0.291-0.6501-0.65-0.6501z"
          clipRule="evenodd"
          fill="url(#paint0_linear_610_1042)"
          fillRule="evenodd"
        />
      </g>
    </>
  ),
  datadog: () => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7491 16.6185L16.9693 15.412L15.4845 17.9608L13.7577 17.4419L12.2373 19.8269L12.3152 20.5776L20.582 19.0122L20.1019 13.7038L18.7491 16.6185ZM11.0396 14.3298L12.3659 14.1423C12.5805 14.2414 12.7299 14.2792 12.9873 14.3465C13.388 14.4538 13.8519 14.5567 14.5389 14.2009C14.6988 14.1195 15.0319 13.8065 15.1665 13.6281L20.6008 12.6149L21.1552 19.5103L11.8453 21.2347L11.0396 14.3298ZM21.1342 11.8452L20.5978 11.9502L19.5672 1.00781L2.00781 3.10036L4.17108 21.142L6.22641 20.8354C6.06228 20.5946 5.8067 20.3032 5.37025 19.9301C4.76492 19.4133 4.97902 18.5354 5.33602 17.9811C5.80845 17.0444 8.24253 15.8541 8.10462 14.357C8.05516 13.8127 7.97096 13.104 7.4793 12.6185C7.46081 12.8201 7.49404 13.0142 7.49404 13.0142C7.49404 13.0142 7.29218 12.7494 7.1915 12.3885C7.09157 12.2501 7.01312 12.2059 6.90694 12.021C6.83125 12.2349 6.84124 12.4829 6.84124 12.4829C6.84124 12.4829 6.6761 12.0819 6.64937 11.7435C6.55144 11.895 6.52671 12.1828 6.52671 12.1828C6.52671 12.1828 6.3121 11.5507 6.36107 11.2102C6.26314 10.9139 5.97284 10.3259 6.05503 8.98954C6.59091 9.37544 7.7706 9.28378 8.23028 8.58746C8.38293 8.35689 8.48736 7.72733 8.15409 6.48695C7.93998 5.69153 7.40985 4.50712 7.20324 4.0578L7.17851 4.07603C7.28743 4.43805 7.51203 5.19702 7.59822 5.56495C7.85904 6.68106 7.92899 7.06953 7.80658 7.58406C7.7024 8.03133 7.45257 8.32403 6.81926 8.65113C6.18594 8.97927 5.34552 8.18076 5.2923 8.1366C4.67698 7.63285 4.20105 6.81098 4.14784 6.41172C4.09263 5.97473 4.39292 5.71232 4.54432 5.35492C4.32772 5.4186 4.08613 5.53157 4.08613 5.53157C4.08613 5.53157 4.37444 5.225 4.72994 4.95978C4.87709 4.85964 4.96353 4.79597 5.11867 4.66348C4.89408 4.65963 4.7117 4.66631 4.7117 4.66631C4.7117 4.66631 5.0862 4.45833 5.47443 4.30685C5.19037 4.29401 4.91856 4.3048 4.91856 4.3048C4.91856 4.3048 5.75424 3.92069 6.41428 3.63877C6.86822 3.44749 7.31167 3.50398 7.56075 3.87422C7.88777 4.35923 8.23128 4.62266 8.95928 4.78595C9.40623 4.58235 9.54213 4.47759 10.1037 4.32046C10.5982 3.76176 10.9864 3.68936 10.9864 3.68936C10.9864 3.68936 10.7938 3.87088 10.7423 4.15614C11.0226 3.92916 11.3299 3.73968 11.3299 3.73968C11.3299 3.73968 11.211 3.89065 11.1001 4.13046L11.1258 4.16974C11.4528 3.96819 11.8373 3.80926 11.8373 3.80926C11.8373 3.80926 11.7274 3.95202 11.5985 4.13688C11.8451 4.13482 12.3452 4.14766 12.5393 4.17026C13.6853 4.19619 13.9231 2.91242 14.3628 2.75143C14.9134 2.54937 15.1595 2.42715 16.0979 3.37432C16.9031 4.18746 17.5321 5.643 17.2199 5.96908C16.958 6.2397 16.4414 5.86355 15.8688 5.13C15.5662 4.74154 15.3374 4.28246 15.2302 3.69886C15.1398 3.2064 14.7878 2.92063 14.7878 2.92063C14.7878 2.92063 14.9921 3.38741 14.9921 3.79976C14.9921 4.02493 15.0196 4.86683 15.3709 5.33926C15.3361 5.40833 15.3199 5.681 15.2814 5.73312C14.8727 5.22552 13.9951 4.86221 13.8519 4.75514C14.3363 5.16313 15.4498 6.10028 15.8775 6.99841C16.282 7.84775 16.0437 8.62623 16.2483 8.82778C16.3065 8.88555 17.1182 9.92489 17.2743 10.4471C17.5466 11.3573 17.2906 12.3137 16.9341 12.9071L15.9385 13.0665C15.7928 13.0249 15.6947 13.0041 15.564 12.9264C15.6359 12.7954 15.7791 12.4688 15.7806 12.4015L15.7244 12.3001C15.4146 12.7512 14.8955 13.1893 14.4643 13.4409C13.8999 13.7695 13.2493 13.719 12.8259 13.5842C11.624 13.2031 10.4875 12.3684 10.2134 12.1492C10.2134 12.1492 10.2049 12.3243 10.2566 12.3635C10.5597 12.7148 11.254 13.3503 11.925 13.7932L10.4945 13.9549L11.1708 19.3668C10.871 19.4109 10.8243 19.4325 10.496 19.4805C10.2067 18.4301 9.65331 17.7443 9.04847 17.3448C8.51509 16.9926 7.77935 16.9132 7.07508 17.0565L7.02986 17.1104C7.51952 17.058 8.09763 17.131 8.69147 17.5174C9.27432 17.8961 9.744 18.8743 9.91688 19.4633C10.1382 20.2161 10.2914 21.0213 9.69553 21.8748C9.27157 22.4815 8.03392 22.8168 7.03411 22.0915C7.30117 22.5328 7.66218 22.8938 8.14809 22.9619C8.8696 23.0625 9.55438 22.9339 10.0258 22.4365C10.4283 22.0113 10.6416 21.1222 10.5854 20.1858L11.2222 20.0908L11.4521 21.7715L21.9943 20.467L21.1342 11.8452ZM14.7203 7.28084C14.6908 7.3499 14.6446 7.39509 14.7141 7.61975L14.7183 7.63259L14.7293 7.6616L14.7583 7.72887C14.8835 7.99179 15.0209 8.23981 15.2505 8.36639C15.3099 8.35612 15.3714 8.34919 15.4351 8.34585C15.6507 8.3361 15.7868 8.37127 15.8733 8.41903C15.881 8.37487 15.8828 8.31016 15.878 8.21491C15.8613 7.8819 15.9422 7.3155 15.3194 7.01741C15.0843 6.9052 14.7546 6.93987 14.6446 7.0798C14.6646 7.08236 14.6826 7.08673 14.6966 7.09161C14.8627 7.15143 14.7501 7.21023 14.7203 7.28084ZM16.4659 10.3881C16.3842 10.3419 16.0024 10.3601 15.7341 10.393C15.223 10.4548 14.6711 10.6371 14.5502 10.7342C14.3303 10.9088 14.4303 11.2133 14.5927 11.3383C15.0481 11.688 15.4473 11.9224 15.8688 11.8654C16.1276 11.8305 16.3557 11.4094 16.5173 11.0274C16.628 10.7642 16.628 10.4803 16.4659 10.3881ZM11.9405 7.69318C12.0846 7.55248 11.2225 7.36762 10.5534 7.83645C10.06 8.1823 10.0443 8.92381 10.5167 9.34412C10.5639 9.38571 10.6029 9.41524 10.6394 9.43937C10.7773 9.37261 10.9344 9.30509 11.1153 9.24475C11.4208 9.14282 11.6749 9.09018 11.8838 9.0622C11.9837 8.94743 12.0999 8.74536 12.0709 8.37949C12.0314 7.88318 11.6654 7.96201 11.9405 7.69318Z"
        fill="#632CA6"
      />
    </>
  ),
  opsgenie_colored: () => (
    <>
      <path
        d="M12 12C15.3137 12 18 9.3137 18 5.99998C18 2.68628 15.3137 0 12 0C8.68629 0 6 2.68628 6 5.99998C6 9.3137 8.68629 12 12 12Z"
        fill="url(#paint0_linear_3580_69212)"
      />
      <path
        d="M11.2255 23.8474C7.46232 21.4108 4.3155 18.0852 2.07706 14.134C1.91485 13.8046 2.01217 13.4095 2.33658 13.2449H2.36902L6.74856 11.0717C7.04057 10.9071 7.42986 11.0388 7.59205 11.3352C9.79805 15.0888 13.0747 18.1181 17 19.9621C15.5726 21.4437 13.9505 22.7609 12.2312 23.8804C11.9067 24.045 11.5174 24.045 11.2255 23.8474Z"
        fill="url(#paint1_linear_3580_69212)"
      />
      <path
        d="M12.1595 23.8474C16.1736 21.4108 19.5301 18.0852 21.9178 14.134C22.0908 13.8046 21.987 13.4095 21.641 13.2449H21.6063L16.9348 11.0717C16.6234 10.9071 16.2082 11.0388 16.0351 11.3352C13.6821 15.0888 10.1871 18.1181 6 19.9621C7.52259 21.4437 9.25271 22.7609 11.0868 23.8804C11.4328 24.045 11.848 24.045 12.1595 23.8474Z"
        fill="#2684FF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3580_69212"
          x1="12.0026"
          y1="1.98654"
          x2="12.0026"
          y2="14.3238"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#2684FF" />
          <stop offset="0.82" stopColor="#0052CC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3580_69212"
          x1="8.15183"
          y1="14.1242"
          x2="12.2264"
          y2="22.526"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#2684FF" />
          <stop offset="0.62" stopColor="#0052CC" />
        </linearGradient>
      </defs>
    </>
  ),
  pagerduty: () => (
    <path
      fill="#06AC38"
      d="M16.965 1.18C15.085.164 13.769 0 10.683 0H3.73v14.55h6.926c2.743 0 4.8-.164 6.61-1.37 1.975-1.303 3.004-3.484 3.004-6.007 0-2.716-1.262-4.896-3.305-5.994zm-5.5 10.326h-4.21V3.113l3.977-.027c3.62-.028 5.43 1.234 5.43 4.128 0 3.113-2.248 4.292-5.197 4.292zM3.73 17.61h3.525V24H3.73Z"
    />
  ),
};

export const public_icons = {
  example: '/icons/example.svg',
  shopify: '/icons/shopify.png',
  bridge: '/icons/bridge.png',
  discord: '/icons/discord.png',
  enode: '/icons/enode.png',
  favro: '/icons/favro.png',
  nmi: '/icons/nmi.png',
  paypal: '/icons/paypal.png',
  upollo: '/icons/upollo.png',
  ebay: '/icons/ebay.png',
  mailchimp: '/icons/mailchimp.png',
  orb: '/icons/orb.png',
  zoom: '/icons/zoom.png',
  xero: '/icons/xero.png',
  woocommerce: '/icons/woocommerce.png',
  workos: '/icons/workos.png',
  trello: '/icons/trello.png',
  twilio: '/icons/twilio.png',
  treezor: '/icons/treezor.png',
  paddle: '/icons/paddle.png',
  bigcommerce: '/icons/bigcommerce.png',
  smile: '/icons/smile.png',
  linkedin: '/icons/linkedin.png',
  docusign: '/icons/docusign.png',
  fireblocks: '/icons/fireblocks.png',
  strava: '/icons/strava.png',
  aiprise: '/icons/aiprise.png',
  polar: '/icons/polar.png',
  tally: '/icons/tally.svg',
  typeform: '/icons/typeform.png',
  okta: '/icons/okta.png',
};

export const material_icon_mapping = {
  retry: 'replay',
  success: 'check_circle',
  error: 'report',
  info: 'info',
  warning: 'warning',
  close: 'close',
  connections: 'account_tree',
  issues: 'inbox',
  metrics: 'insert_chart',
  requests: 'exit_to_app',
  leave: 'exit_to_app',
  events: 'ungroup',
  bookmarks: 'bookmarks',
  help: 'contact_support',
  docs: 'description',
  upgrade: 'ambient_screen',
  expand_more: 'expand_more',
  expand_less: 'expand_less',
  terminal: 'terminal',
  http: 'language',
  settings: 'settings',
  add: 'add',
  add_circle: 'add_circle',
  export_notes: 'export_notes',
  export: 'ios_share',
  check: 'check',
  chat: 'mark_unread_chat_alt',
  email: 'forward_to_inbox',
  new_releases: 'award_star',
  changelog: 'rss_feed',
  chevron_left: 'chevron_left',
  wallet: 'wallet',
  key: 'key',
  group: 'group',
  tune: 'tune',
  account: 'account_circle',
  save: 'save',
  view: 'visibility',
  dismiss: 'visibility_off',
  link: 'arrow_outward',
  connect: 'power',
  disconnect: 'power_off',
  delete: 'delete',
  copy: 'content_copy',
  roll: 'flip_camera_android',
  edit: 'edit',
  checklist: 'checklist',
  sort: 'swap_vert',
  filter: 'filter_alt',
  open: 'arrow_outward',
  notification: 'notifications_active',
  notification_off: 'notifications_off',
  arrow_downward: 'arrow_downward',
  inbox: 'inbox',
  send: 'send',
  transformation: 'flip',
  swap: 'swap_horiz',
  rate_limit: 'readiness_score',
  done_all: 'done_all',
  remove_done: 'remove_done',
  awknowledged: 'mystery',
  history: 'history',
  visibility: 'visibility',
  issue_trigger: 'destruction',
  cancel: 'cancel',
  refresh: 'source_notes',
  reload: 'refresh',
  date: 'calendar_month',
  notes: 'notes',
  keyboard: 'keyboard',
  data_object: 'data_object',
  arrow_forward: 'arrow_forward',
  rotate_left: 'rotate_left',
  chevron_right: 'chevron_right',
  subdirectory: 'subdirectory_arrow_right',
  block: 'block',
  autorenew: 'autorenew',
  source: 'send_money',
  status: 'bolt',
  search: 'search',
  logout: 'logout',
  dark_mode: 'dark_mode',
  light_mode: 'light_mode',
  vertical_more: 'more_vert',
  horizontal_more: 'more_horiz',
  arrow_drop_up: 'arrow_drop_up',
  arrow_drop_down: 'arrow_drop_down',
  visibility_off: 'visibility_off',
  expand_all: 'expand_all',
  collapse_all: 'collapse_all',
  destinations: 'target',
  destination: 'target',
  person: 'person',
  bookmark_add: 'bookmark_add',
  bookmark_remove: 'bookmark_remove',
  bookmark: 'bookmark',
  replay: 'autoplay',
  schedule: 'chronic',
  pause_circle: 'pause_circle',
  play_circle: 'play_circle',
  disable: 'do_not_disturb_on',
  enable: 'power_settings_new',
  inventory: 'inventory_2',
  verification: 'verified_user',
  api: 'api',
  rule: 'rule',
  document: 'description',
  change: 'flip_camera_android',
  auto_awesome: 'auto_awesome',
  clear: 'delete_sweep',
  lock: 'lock',
  gavel: 'gavel',
  edit_square: 'edit_square',
  success_circle: 'check_circle',
  download: 'download',
  undo: 'undo',
  plagiarism: 'plagiarism',
  right_panel_close: 'right_panel_close',
  left_panel_close: 'left_panel_close',
  folder: 'folder',
  transfer: 'local_shipping',
  construction: 'construction',
  progress_activity: 'progress_activity',
  throughput: 'earthquake',
  code: 'code',
  grid_view: 'grid_view',
  bolt: 'bolt',
  computer: 'computer',
};

function InvertIcon({ icon }: { icon: React.ReactNode }) {
  return (
    <div style={{ filter: 'invert(1)', height: '100%', display: 'flex', alignItems: 'center' }}>
      {icon}
    </div>
  );
}

export const platforms_icons_mapping = {
  webhook: {
    light: WebhookLightIcon,
  },
  '3dEye': {
    light: ThreeDEyeLightIcon,
    dark: ThreeDEyeDarkIcon,
  },
  adyen: {
    light: AdyenLightIcon,
  },
  airwallex: {
    light: AirwallexLightIcon,
  },
  akeneo: {
    light: AkeneoLightIcon,
  },
  awssns: {
    light: AWSSNSLightIcon,
  },
  awssqs: {
    light: AWSSQSLightIcon,
  },
  awss3: {
    light: AWSS3LightIcon,
  },
  bondsmith: {
    light: BondsmithLightIcon,
  },
  cloudsignals: {
    light: CloudsignalsLightIcon,
  },
  gocardless: {
    light: GocardlessLightIcon,
  },
  commercelayer: {
    light: CommercelayerLightIcon,
    dark: () => <InvertIcon icon={<CommercelayerLightIcon />} />,
  },
  courier: {
    light: CourierLightIcon,
  },
  customerio: {
    light: CustomerioLightIcon,
  },
  facebook: {
    light: FacebookLightIcon,
  },
  fiserv: {
    light: FiservLightIcon,
  },
  frontapp: {
    light: FrontappLightIcon,
  },
  github: {
    light: GitHubLightIcon,
    dark: () => <InvertIcon icon={<GitHubLightIcon />} />,
  },
  gitlab: {
    light: GitLabLightIcon,
  },
  hubspot: {
    light: HubSpotLightIcon,
  },
  linear: {
    light: LinearLightIcon,
  },
  mailgun: {
    light: MailgunLightIcon,
  },
  oura: {
    light: OuraLightIcon,
    dark: () => <InvertIcon icon={<OuraLightIcon />} />,
  },
  persona: {
    light: PersonaLightIcon,
  },
  pipedrive: {
    light: PipedriveLightIcon,
  },
  postmark: {
    light: PostmarkLightIcon,
  },
  praxis: {
    light: PraxisLightIcon,
    dark: () => <InvertIcon icon={<PraxisLightIcon />} />,
  },
  propertyfinder: {
    light: PropertyFinderLightIcon,
  },
  pylon: {
    light: PylonLightIcon,
  },
  razorpay: {
    light: RazorpayLightIcon,
  },
  recharge: {
    light: RechargeLightIcon,
  },
  repay: {
    light: RepayLightIcon,
  },
  replicate: {
    light: ReplicateLightIcon,
  },
  sanity: {
    light: SanityLightIcon,
  },
  sendgrid: {
    light: SendgridLightIcon,
  },
  shopline: {
    light: ShoplineLightIcon,
    dark: () => <InvertIcon icon={<ShoplineLightIcon />} />,
  },
  slack: {
    light: SlackLightIcon,
  },
  solidgate: {
    light: SolidgateLightIcon,
  },
  square: {
    light: SquareLightIcon,
    dark: () => <InvertIcon icon={<SquareLightIcon />} />,
  },
  stripe: {
    light: StripeLightIcon,
  },
  svix: {
    light: SvixLightIcon,
  },
  synctera: {
    light: SyncteraLightIcon,
  },
  tebex: {
    light: TebexLightIcon,
  },
  telnyx: {
    light: TelnyxLightIcon,
  },
  tiktok: {
    light: TikTokLightIcon,
    dark: () => <InvertIcon icon={<TikTokLightIcon />} />,
  },
  tokenio: {
    light: TokenioLightIcon,
    dark: () => <InvertIcon icon={<TokenioLightIcon />} />,
  },
  treezor: {
    light: TreezorLightIcon,
  },
  twitch: {
    light: TwitchLightIcon,
  },
  typeform: {
    light: TypeformLightIcon,
    dark: () => <InvertIcon icon={<TypeformLightIcon />} />,
  },
  vercel: {
    light: VercelLightIcon,
    dark: () => <InvertIcon icon={<VercelLightIcon />} />,
  },
  whatsapp: {
    light: WhatsAppLightIcon,
  },
  wix: {
    light: WixLightIcon,
    dark: () => <InvertIcon icon={<WixLightIcon />} />,
  },
  x: {
    light: XLightIcon,
    dark: () => <InvertIcon icon={<XLightIcon />} />,
  },
  zendesk: {
    light: ZendeskLightIcon,
    dark: ZendeskDarkIcon,
  },
};

export type IconName =
  | keyof typeof svg_icons
  | keyof typeof material_icon_mapping
  | keyof typeof platforms_icons_mapping
  | keyof typeof public_icons;

export interface IconTheme {
  primary?: boolean;
  danger?: boolean;
  warning?: boolean;
  success?: boolean;
  dark?: boolean;
  muted?: boolean;
  light?: boolean;
}

interface Props
  extends Pick<StyledUtilsProps, 'padding' | 'margin' | 'p' | 'm' | 'style'>,
    ComponentProps<typeof Div>,
    IconTheme {
  icon?: IconName;
  src?: string;

  large?: boolean;
  small?: boolean; // Default size

  left?: boolean | SpacingGridMultiple | number;
  right?: boolean | SpacingGridMultiple | number;

  pointer?: boolean;
}

export const StyledIcon = styled(Div)<Props & { rounded?: boolean; is_platform?: boolean }>(
  ({ theme, rounded, is_platform, ...props }) => css`
    color: currentColor;
    fill: ${is_platform ? 'unset' : 'currentColor'};
    vertical-align: sub;
    flex: none;
    text-align: center;
    cursor: ${props.pointer ? 'pointer' : 'default'};

    ${rounded &&
    css`
      border-radius: ${theme.pxToRem(2)};
      overflow: hidden;
    `}

    ${theme.optionsToCss(
      {
        large: css`
          height: ${theme.pxToRem(24)};
          width: ${theme.pxToRem(24)};
          font-size: ${theme.pxToRem(24)} !important;
          font-variation-settings:
            'FILL' 0,
            'wght' 400,
            'GRAD' 0,
            'opsz' 24;
        `,
        small: css`
          height: ${theme.pxToRem(16)};
          width: ${theme.pxToRem(16)};
          font-size: ${theme.pxToRem(16)} !important;
          font-variation-settings:
            'FILL' 0,
            'wght' 400,
            'GRAD' 0,
            'opsz' 20;
        `,
      },
      props,
      'small',
    )}

    ${theme.optionsToCss(
      {
        muted: css`
          color: ${theme.colors.on.neutral.secondary_neutral};
        `,
        primary: css`
          color: ${theme.colors.on.hue_container.primary};
        `,
        warning: css`
          color: ${theme.colors.on.hue_container.warning};
        `,
        danger: css`
          color: ${theme.colors.on.hue_container.danger};
        `,
        success: css`
          color: ${theme.colors.on.hue_container.success};
        `,
      },
      props,
    )}

    ${props.right &&
    css`
      margin-left: ${theme.spacing(
        typeof props.right === 'number' ? (props.right as SpacingGridMultiple) : 2,
      )};
    `}
    ${props.left &&
    css`
      margin-right: ${theme.spacing(
        typeof props.left === 'number' ? (props.left as SpacingGridMultiple) : 2,
      )};
    `}
  `,
);

const Icon = ({ icon, ...props }: Props) => {
  const theme = useTheme();

  if (!icon) {
    return <StyledIcon as="img" {...props} />;
  }
  if (platforms_icons_mapping[icon]) {
    const PlatformIcon =
      theme.mode === 'dark' && platforms_icons_mapping[icon].dark
        ? platforms_icons_mapping[icon].dark
        : platforms_icons_mapping[icon].light || platforms_icons_mapping[icon];

    return (
      <StyledIcon
        {...props}
        is_platform
        as="span"
        rounded
        flex={{ align: 'center', justify: 'center' }}>
        <PlatformIcon />
      </StyledIcon>
    );
  }
  if (material_icon_mapping[icon]) {
    return (
      <StyledIcon {...props} as="span" className="material-symbols-rounded">
        {material_icon_mapping[icon]}
      </StyledIcon>
    );
  }
  if (public_icons[icon]) {
    return <StyledIcon {...props} as="img" rounded src={public_icons[icon]} alt={icon} />;
  }

  return (
    <StyledIcon {...props} as="svg" viewBox="0 0 24 24">
      {svg_icons[icon] && svg_icons[icon](props)}
    </StyledIcon>
  );
};

export default Icon;
